import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';

@Component({
  selector: 'app-lms-multi-select',
  templateUrl: './lms-multi-select.component.html',
  styleUrls: ['./lms-multi-select.component.scss'],
})
export class LmsMultiSelectComponent implements OnInit, OnChanges {
  public displaySelectCount: number;
  public displaySelectName: string;

  @Input() list: any;
  @Input() header: string;
  @Input() clearAll: boolean;
  @Input() selectedItem: any = [];
  @Input() selectionLimit = null;
  @Input() icon = false;
  @Input() disabled = false;
  @Input() placeHolderText = 'Select';
  @Input() toggleAll;

  @Output() shareSelectedItem = new EventEmitter();

  @Output() shareOnChange = new EventEmitter();

  public item: string;
  public selectedCountry: string;

  constructor() { }

  ngOnInit(): void {
    if (this.selectedItem && !this.toggleAll) {
      this.onChange(null, this.selectedItem);
    }

    
  }

  onChange(event, selectedItem): void {
    if (selectedItem.length > 0) {
      this.displaySelectName = selectedItem[0].name;
    }
    if (selectedItem.length > 1) {
      this.displaySelectCount = selectedItem.length - 1;
    }
    this.shareSelectedItem.emit(selectedItem);
  }

  ngOnChanges(): void {
    if (this.list && this.toggleAll) {
      this.selectedItem = this.list;
      this.setDisplaySelectName();
    }
    if (this.clearAll) {
      this.selectedItem = [];
    } else {
      this.setDisplaySelectName();
    }
  }

  setDisplaySelectName(): void {
    if (this.selectedItem != undefined) {
      if (this.selectedItem.length > 0) {
        this.displaySelectName = this.selectedItem[0].name;
      }
      if (this.selectedItem.length > 1) {
        this.displaySelectCount = this.selectedItem.length - 1;
      }
      this.shareSelectedItem.emit(this.selectedItem);
    }
  }
}
